module.exports = __webpack_public_path__ + "img/location.3bc683c4.png";